import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';

const API = axios.create({ baseURL: '/api', withCredentials: true });

const QuoteNew = () => {
  const navigate = useNavigate();
  const [customer, setCustomer] = useState(null);
  const [billTo, setBillTo] = useState('');
  const [quoteDate, setQuoteDate] = useState(new Date().toISOString().split('T')[0]);
  const [validUntil, setValidUntil] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem('selected_customer');
    if (!stored) { navigate('/select-customer'); return; }
    const c = JSON.parse(stored);
    setCustomer(c);
    setBillTo(c.name || '');
  }, [navigate]);

  const handleCreate = async () => {
    if (!billTo.trim()) return toast.error('Bill To is required');
    setSaving(true);
    try {
      const res = await API.post('/quotes', {
        customer_id: customer.customer_id,
        bill_to: billTo.trim(),
        quote_date: quoteDate || null,
        valid_until: validUntil || null
      });
      toast.success(`Quote ${res.data.quote_number} created`);
      navigate(`/quotes/${res.data.quote_id}/edit`);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to create quote');
      setSaving(false);
    }
  };

  if (!customer) return null;

  const label = { display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '6px' };
  const input = { width: '100%', padding: '9px 12px', border: '1px solid #E2E8F0', borderRadius: '6px', fontSize: '14px', outline: 'none' };

  return (
    <div className="fcc-fade-in" style={{ padding: '24px', maxWidth: '520px', margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1 style={{ fontSize: '22px', fontWeight: '600' }}>New Quote</h1>
        <button onClick={() => navigate('/quotes')} style={{ background: 'none', border: '1px solid #E2E8F0', borderRadius: '6px', padding: '8px 16px', cursor: 'pointer', fontSize: '14px', color: '#0F1B2D' }}>
          ← Back
        </button>
      </div>

      <div style={{ background: 'white', border: '1px solid #E2E8F0', borderRadius: '10px', padding: '24px' }}>
        <p style={{ color: '#5B6B7F', fontSize: '14px', marginBottom: '20px' }}>
          Customer: <strong>{customer.name}</strong>
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div>
            <label style={label}>Bill To *</label>
            <input style={input} value={billTo} onChange={e => setBillTo(e.target.value)} placeholder="e.g. Maersk" autoFocus />
          </div>
          <div style={{ display: 'flex', gap: '16px' }}>
            <div style={{ flex: 1 }}>
              <label style={label}>Quote Date</label>
              <input type="date" style={input} value={quoteDate} onChange={e => setQuoteDate(e.target.value)} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={label}>Valid Until <span style={{ color: '#8595A6', fontWeight: 400 }}>(optional)</span></label>
              <input type="date" style={input} value={validUntil} onChange={e => setValidUntil(e.target.value)} />
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '10px', marginTop: '24px', justifyContent: 'flex-end' }}>
          <button onClick={() => navigate('/quotes')} style={{ background: 'none', border: '1px solid #E2E8F0', borderRadius: '6px', padding: '9px 18px', cursor: 'pointer', fontSize: '14px', color: '#0F1B2D' }}>
            Cancel
          </button>
          <button onClick={handleCreate} disabled={saving} className="btn btn-primary" style={{ width: 'auto', padding: '9px 22px' }}>
            {saving ? 'Creating...' : 'Create & Add Lines'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuoteNew;
